import { render } from "./Plot.vue?vue&type=template&id=ee6ef3e2&scoped=true"
import script from "./Plot.vue?vue&type=script&lang=js"
export * from "./Plot.vue?vue&type=script&lang=js"

import "./Plot.vue?vue&type=style&index=0&id=ee6ef3e2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dendro-plots/dendro-plots/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee6ef3e2"]])

export default __exports__